import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EdlCommonComponentsModule, EdlCommonPipesModule } from '@edl-development/edl-common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LaddaModule } from 'angular2-ladda';
import { PipesModule } from '../pipes/pipes.module';
import { A48IconComponent } from './a48-icon/a48-icon.component';
import { BaseItemStatusIndicatorComponent } from './base-item-status-indicator/base-item-status-indicator.component';
import { ComplyPaginationComponent } from './comply-pagination/comply-pagination.component';
import { EdllNotesComponent } from './edl-notes/edl-notes.component';
import { HistoryItemComponent } from './history-item/history-item.component';
import { ItemStatusIndicatorComponent } from './item-status-indicator/item-status-indicator.component';
import { ItemSubTypeInfoComponent } from './item-sub-type-info/item-sub-type-info.component';
import { TimeTrackingStatusIndicatorComponent } from './timetracking-status/timetracking-status-indicator.component';
import { UserCycleHistoryItemComponent } from './user-cycle-history-item/user-cycle-history-item.component';
import { VerificationActionIndicatorComponent } from './verification-status-indicator/verification-action-indicator.component';
import { FlexIconComponent } from './flex-icon/flex-icon.component';
import { ComplyDirectivesModule } from '../directives/comply-directives.module';
import { StatusAggregationIndicatorComponent } from '../status-aggregation-indicator/status-aggregation-indicator.component';
import { EdlIconModule } from './edl-icon/edl-icon.module';
import { NavigationBackButtonComponent } from './navigation-back-button/navigation-back-button.component';
import { PaginationLoadingOverlayComponent } from './pagination-loading-overlay/pagination-loading-overlay.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        LaddaModule,
        EdlCommonPipesModule,
        PipesModule,
        EdlCommonComponentsModule,
        ComplyDirectivesModule,
        EdlIconModule
    ],
    declarations: [
        HistoryItemComponent,
        UserCycleHistoryItemComponent,
        ItemStatusIndicatorComponent,
        TimeTrackingStatusIndicatorComponent,
        VerificationActionIndicatorComponent,
        EdllNotesComponent,
        ItemSubTypeInfoComponent,
        ComplyPaginationComponent,
        BaseItemStatusIndicatorComponent,
        A48IconComponent,
        FlexIconComponent,
        StatusAggregationIndicatorComponent,
        NavigationBackButtonComponent,
        PaginationLoadingOverlayComponent
    ],
    exports: [
        HistoryItemComponent,
        UserCycleHistoryItemComponent,
        ItemStatusIndicatorComponent,
        TimeTrackingStatusIndicatorComponent,
        EdllNotesComponent,
        VerificationActionIndicatorComponent,
        ItemSubTypeInfoComponent,
        ComplyPaginationComponent,
        BaseItemStatusIndicatorComponent,
        A48IconComponent,
        FlexIconComponent,
        StatusAggregationIndicatorComponent,
        EdlIconModule,
        NavigationBackButtonComponent,
        PaginationLoadingOverlayComponent
    ]
})
export class ComponentModule { }
